import React from 'react';
import Icon from '../../../components/AppIcon';

const FeasibilityIndexCard = ({ score, confidence }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-warning';
    return 'text-error';
  };

  const getScoreBackground = (score) => {
    if (score >= 80) return 'bg-success/10 border-success/20';
    if (score >= 60) return 'bg-warning/10 border-warning/20';
    return 'bg-error/10 border-error/20';
  };

  const getConfidenceIcon = (confidence) => {
    if (confidence === 'high') return 'TrendingUp';
    if (confidence === 'medium') return 'Minus';
    return 'TrendingDown';
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8 elevation-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center">
          <Icon name="Target" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Goal Feasibility Index
        </h3>
      </div>

      <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
        <div className={`relative w-32 h-32 md:w-40 md:h-40 rounded-full border-8 ${getScoreBackground(score)} flex items-center justify-center`}>
          <div className="text-center">
            <div className={`text-3xl md:text-4xl font-heading font-bold ${getScoreColor(score)}`}>
              {score}%
            </div>
            <div className="text-xs text-muted-foreground font-caption mt-1">
              Feasibility
            </div>
          </div>
        </div>

        <div className="flex-1 w-full">
          <div className="space-y-4">
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-foreground font-body">
                  Confidence Level
                </span>
                <span className="text-sm font-medium text-foreground font-body capitalize">
                  {confidence}
                </span>
              </div>
              <div className="h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className={`h-full transition-smooth ${
                    confidence === 'high' ?'bg-success w-full'
                      : confidence === 'medium' ?'bg-warning w-2/3' :'bg-error w-1/3'
                  }`}
                />
              </div>
            </div>

            <div className="flex items-start gap-3 p-4 bg-muted/50 rounded-lg">
              <Icon
                name={getConfidenceIcon(confidence)}
                size={18}
                color="var(--color-muted-foreground)"
                className="flex-shrink-0 mt-0.5"
              />
              <p className="text-sm text-muted-foreground font-body">
                {confidence === 'high' ?'Based on your business model and current trajectory, this goal is highly achievable with consistent execution.'
                  : confidence === 'medium' ?'This goal is achievable but requires strategic adjustments and focused effort in key areas.' :'This goal presents significant challenges. Consider breaking it into smaller milestones or extending the timeline.'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeasibilityIndexCard;